import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const page = usePage();

const baseUrl = computed(() => page.props.ziggy.url);

export function useIsExternalUrl(url) {
    if (typeof url !== 'string' && !(url instanceof String)) {
        return false;
    }

    return !(url.startsWith('/') || url.includes(baseUrl.value));
}
